import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';

/**
 * Scroll to the top on navigation, or to the #anchor when there is one. The
 * sticky header is tall, so anchored sections carry `scroll-mt-32`.
 */
export function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // Wait a frame so the target page has rendered.
      const id = decodeURIComponent(hash.slice(1));
      requestAnimationFrame(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' }));
      return;
    }
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname, hash]);
  return null;
}

export function SiteLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-ink-base">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-white focus:px-3 focus:py-2 focus:rounded">
        Skip to content
      </a>
      <SiteHeader />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}

/** Sets the document title for a page. */
export function usePageTitle(title: string) {
  useEffect(() => {
    document.title = title ? `${title} | Scada.Ink` : 'Scada.Ink — Industrial Monitoring & Analytics';
  }, [title]);
}
